module.exports = require("@swa-ui/placements/src/TextBlock/TextBlock.module.scss");